module.exports = __webpack_public_path__ + "static/media/one-pocket.524cb440.png";